import request from '@/utils/http';
const otpBaseUrl = '/api-antms/receipt';

// 回单反查-查询接口
export const receiptList = (data) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/task/query`,
        method: 'POST',
        data
    });
};

// 回单反查-任务生成接口
export const makeByDiy = (data) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/task/makeByDiy`,
        method: 'POST',
        data
    });
};

// 回单反查-保存上传附件接口
export const fileSave = (data) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/record/file/save`,
        method: 'POST',
        data
    });
};

// 回单反查-回单反查记录保存接口
export const recordSave = (data) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/record/save`,
        method: 'POST',
        data
    });
};

// 签收中心 反查 保存
export const saveFromSignCenter = (params) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/record/saveFromSignCenter`,
        method: 'post',
        data: params
    });
};

// 回单反查-回单反查记录查询接口
export const recordQuery = (data) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/record/query`,
        method: 'POST',
        data
    });
};

// 回单反查-回单反查记录附件查询接口
export const fileQuery = (data) => {
    return request({
        url: `/api-antms/transport/attachment/list`,
        method: 'get',
        params: data
    });
};

// 回单反查-印鉴查询接口
export const queryByTaskNo = (param) => {
    return request({
        url: `/api-antms/query/receipt/registration/queryByTaskNo?taskNo=${param}`,
        method: 'get'
    });
};

// 回单反查-删除反查记录附件
export const fileDelete = (param) => {
    return request({
        url: `/api-antms/transport/attachment/delete?id=${param}`,
        method: 'get'
    });
};

// 回单反查-查询附件id及发车单号
export const dispatchNoQuery = (param) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/task/receiptDetailHandler?taskNo=${param}`,
        method: 'get'
    });
};

// 回单反查-回单整改-保存
export const rectificationSave = (params) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/rectification/save`,
        method: 'post',
        data: params
    });
};

// 回单反查-整改记录-查询
export const rectificationQuery = (params) => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/rectification/query`,
        method: 'post',
        data: params
    });
};

// 签收中心-回单上传接口
export const uploadReceipt = data => {
    return request({
        url: `${otpBaseUrl}/receipt/upload`,
        method: 'post',
        data
    });
};

// 一级异常原因查询
export const exception = param => {
    return request({
        url: `${otpBaseUrl}/receipt/recheck/exception?taskNo=${param}`,
        method: 'get'
    });
};
